// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__M5j1S","footer":"ChangeClinic_footer__1ED1o"};